namespace Portico.Models.Legacy {
    
    export class GuardianInfoModel {
        personId: number;
        namePrefix: string;
        firstName: string;
        middleName: string;
        lastName: string;
        nameSuffix: string;
        dateOfBirth: string;
        relationship: RelationshipEnum;
        primaryPhoneNumber: PhoneNumberModel;

        constructor(obj?: Portico.Services.Legacy.EnrollmentService.Models.GuardianInfoModel){
            this.personId = null;
            this.namePrefix = null;
            this.firstName = null;
            this.middleName = null;
            this.lastName = null;
            this.nameSuffix = null;
            this.dateOfBirth = null;
            this.relationship = null;
            this.primaryPhoneNumber = null;

            if(obj){
                this.personId = obj.personId || null;
                this.namePrefix = obj.namePrefix || null;
                this.firstName = obj.firstName || null;
                this.middleName = obj.middleName || null;
                this.lastName = obj.lastName || null;
                this.nameSuffix = obj.nameSuffix || null;
                this.dateOfBirth = obj.dateOfBirth || null;
                this.relationship = obj.relationship || null;
                this.primaryPhoneNumber = new PhoneNumberModel(obj.primaryPhoneNumber || null);
            }
        }

        public toModel(): Portico.Services.Legacy.EnrollmentService.Models.GuardianInfoModel {
            return {
                personId: this.personId,
                namePrefix: this.namePrefix,
                firstName: this.firstName,
                middleName: this.middleName,
                lastName: this.lastName,
                nameSuffix: this.nameSuffix,
                dateOfBirth: this.dateOfBirth,
                relationship: this.relationship,
                primaryPhoneNumber: this.primaryPhoneNumber.toModel(),
            };
        }
    }   
}